import type { ReactElement } from 'react';

import styles from './Spinner.module.css';

export interface SpinnerProps {
    size?: 'sm' | 'md' | undefined;
    /** Announced to assistive technology. */
    label: string;
}

export function Spinner({ size = 'md', label }: SpinnerProps): ReactElement {
    return (
        <span role="status" className={[styles.spinner, styles[size]].join(' ')}>
            <span className="visually-hidden">{label}</span>
        </span>
    );
}
